var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColdPlunge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 148,
    viewBox: "0 0 276 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 124C74.6995 124 55 104.301 55 80C55 55.6995 74.6995 36 99 36C123.301 36 143 55.6995 143 80C143 104.301 123.301 124 99 124Z",
    fill: "#6DBFEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127 148C102.699 148 83 128.301 83 104C83 79.6995 102.699 60 127 60C151.301 60 171 79.6995 171 104C171 128.301 151.301 148 127 148Z",
    fill: "#6DBFEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153 97C126.49 97 105 75.5097 105 49C105 22.4903 126.49 1 153 1C179.51 1 201 22.4903 201 49C201 75.5097 179.51 97 153 97Z",
    fill: "#6DBFEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162 139C135.49 139 114 117.51 114 91C114 64.4903 135.49 43 162 43C188.51 43 210 64.4903 210 91C210 117.51 188.51 139 162 139Z",
    fill: "#6DBFEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 94C90.6995 94 71 74.3005 71 50C71 25.6995 90.6995 6 115 6C139.301 6 159 25.6995 159 50C159 74.3005 139.301 94 115 94Z",
    fill: "#6DBFEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 276 69)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 65 136)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 55)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 57 10)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 218 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 230 137)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 20,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#D5EEFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.487 69.5395L108 70L110.28 92.796C110.689 96.8856 114.13 100 118.24 100H151.76C155.87 100 159.311 96.8856 159.72 92.796L162 70L159.513 69.5395C157.588 69.1829 155.612 69.1829 153.687 69.5395L148.713 70.4605C146.788 70.8171 144.812 70.8171 142.887 70.4605L137.913 69.5395C135.988 69.1829 134.012 69.1829 132.087 69.5395L127.113 70.4605C125.188 70.8171 123.212 70.8171 121.287 70.4605L116.313 69.5395C114.388 69.1829 112.412 69.1829 110.487 69.5395Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 3.99997
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.001 40.999L135.001 54.999",
    stroke: "#2C94DA",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.001 36L135.001 60",
    stroke: "#2C94DA",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.393 42L124.609 54",
    stroke: "#2C94DA",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.609 41.999L145.393 53.999",
    stroke: "#2C94DA",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110 90L111.862 89.6276C113.934 89.2133 116.066 89.2133 118.138 89.6276L121.862 90.3724C123.934 90.7867 126.066 90.7867 128.138 90.3724L131.862 89.6276C133.934 89.2133 136.066 89.2133 138.138 89.6276L141.862 90.3724C143.934 90.7867 146.066 90.7867 148.138 90.3724L151.862 89.6276C153.934 89.2133 156.066 89.2133 158.138 89.6276L160 90",
    stroke: "#57B2E8",
    strokeWidth: 3.99997
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109 80L111.178 79.5811C113.175 79.1972 115.225 79.1972 117.222 79.5811L121.578 80.4189C123.575 80.8028 125.625 80.8028 127.622 80.4189L131.978 79.5811C133.975 79.1972 136.025 79.1972 138.022 79.5811L142.378 80.4189C144.375 80.8028 146.425 80.8028 148.422 80.4189L152.778 79.5811C154.775 79.1972 156.825 79.1972 158.822 79.5811L161 80",
    stroke: "#57B2E8",
    strokeWidth: 3.99997
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171 60H170.24C166.13 60 162.689 63.1144 162.28 67.204L159.72 92.796C159.311 96.8856 155.87 100 151.76 100H118.24C114.13 100 110.689 96.8856 110.28 92.796L107.72 67.204C107.311 63.1144 103.87 60 99.7601 60H99",
    stroke: "#2C94DA",
    strokeWidth: 3.99997,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.5L38 32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230 99.5L248.5 103.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221 29.5L237.5 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 120.5L28 116",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdPlunge);
export default __webpack_public_path__ + "static/media/cold-plunge.193a5f3af2d6b2e1a90c34f6a1e8491d.svg";
export { ForwardRef as ReactComponent };